<template>
  <b-card body-class="p-0">
    <div class="flex">
      <div class="w-[64%] border-r p-6">
        <div class="flex items-center h-full">
          <b-button
            variant="primary"
            size="sm"
            class="mr-1 rounded-lg p-0"
            @click="onBack"
          >
            <feather-icon
              size="2x"
              icon="ChevronLeftIcon"
            />
          </b-button>
          <h4 class="font-bold text-black d-inline-flex mb-0">
            Notifikasi WhatsApp Premium
          </h4>
        </div>
      </div>
      <div class="w-[36%]">
        <div class="bg-[#FFF2E2] flex gap-4 h-full items-center p-[12px] rounded-r-md">
          <img
            class="w-8"
            src="https://storage.googleapis.com/komerce/assets/icons/danger-yellow.svg"
            alt="warning"
          >
          <div class="text-black">
            Pedoman untuk mencegah no WA kamu terblokir saat menggunakan fitur ini <a
              href="https://bantuan.komerce.id/id/article/pedoman-agar-mencegah-no-wa-kamu-terblokir-saat-menggunakan-fitur-notifikasi-whatsapp-premium-uy5229/?bust=1686877558855"
              target="_blank"
              style="color: #08A0F7; text-decoration: underline;"
            >pelajari selengkapnya</a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="w-[64%] border-r p-6 flex flex-col items-center text-black space-y-8">
        <img
          class="max-w-[250px]"
          src="https://storage.googleapis.com/komerce/assets/illustration/banner-login-wa.svg"
          alt="wa-illustration"
        >
        <div class="text-center text-[20px] font-bold">
          <div>Terima kasih sudah mengaktifkan fitur</div>
          Notifikasi WhatsApp Premium
        </div>
        <div class="text-center">
          Fitur notifikasi WhatsApp otomatis aktif dengan template notif dari komship. Yuk hubungkan WhatsApp kamu untuk melanjutkan penyesuaian dan buat template notifikasimu sendiri untuk menunjukkan identitas bisnismu
        </div>
      </div>
      <div class="w-[36%] p-6 flex flex-col items-center text-black space-y-8">
        <div>Scan QR di bawah ini menggunakan aplikasi WhatsApp kamu</div>
        <div class="">
          <b-overlay
            variant="light"
            :show="loadingQr"
            spinner-variant="primary"
            blur="0"
            opacity=".5"
            rounded="sm"
            class="w-[200px] h-[200px]"
          >
            <qrcode-vue
              :value="qrCode"
              size="200"
            />
          </b-overlay>
        </div>
        <div
          v-if="phoneNumber"
          class="mt-0"
        >
          <div class="my-[10px] text-center font-bold text-[18px]">
            {{ phoneNumber }}
          </div>
        </div>
        <ol>
          <li class="flex space-x-6">
            <div>1.</div>
            <div>Buka WhatsApp pada telepon Anda dan pastikan scan QR menggunakan nomor yang telah Anda tambahkan</div>
          </li>
          <li class="flex space-x-5">
            <div>2.</div>
            <div>Klik Menu atau Setelan dan pilih Perangkat Tertaut/Linked Device/WhatsApp Web</div>
          </li>
          <li class="flex space-x-5">
            <div>3.</div>
            <div>Klik Tautkan Perangkat</div>
          </li>
          <li class="flex space-x-5">
            <div>4.</div>
            <div>Arahkan telepon kamu ke layar ini untuk memindai kode tersebut</div>
          </li>
        </ol>
      </div>
    </div>
    <b-modal
      id="modal-add-number"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      size="md"
    >
      <div style="padding: 21px 23px;">
        <div
          class="font-bold text-black text-2xl text-center"
          style="margin-bottom: 12px;"
        >
          Tambah Nomor Whatsapp
        </div>
        <div
          class="text-black text-lg text-center"
          style="margin-bottom: 20px;"
        >
          Yuk masukkan Nomor HP kamu yang akan dihubungkan ke fitur Notif WhatsApp
        </div>
        <b-input-group
          prepend="+62"
          style="margin-bottom: 8px;"
        >
          <b-form-input
            v-model="inputPhoneNumber"
            :formatter="formatPhoneNumber"
            @input="inputError = ''"
          />
        </b-input-group>
        <div
          class="text-sm"
          style="margin-bottom: 32px;"
        >
          <div :class="inputError === '' ? 'text-black' : 'text-[#E31A1A]'">
            {{ inputError === '' ? '*Minimal 9 digit berupa angka & wajib diawali dengan angka 8' : inputError }}
          </div>
        </div>
        <div class="d-flex gap-10">
          <b-button
            variant="outline-primary"
            class="w-full"
            @click="onBack"
          >
            Batal
          </b-button>
          <b-button
            :variant="inputPhoneNumber.length < 9 || inputError === '*Nomor yang Anda masukkan tidak terhubung dengan WhatsApp' || inputError === '*Maaf, nomor yang Anda masukkan sudah terdaftar' || isLoading ? 'secondary' : 'primary'"
            class="w-full"
            :disabled="inputPhoneNumber.length < 9 || inputError === '*Nomor yang Anda masukkan tidak terhubung dengan WhatsApp' || inputError === '*Maaf, nomor yang Anda masukkan sudah terdaftar' || isLoading"
            @click="checkNumber()"
          >
            <span v-if="!isLoading">Simpan</span>
            <BSpinner
              v-if="isLoading"
              small
              label="Loading..."
            />
          </b-button>
        </div>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapState } from 'vuex'
import { newAxiosIns } from '@/libs/axios'
import { BSpinner } from 'bootstrap-vue'
import QrcodeVue from 'qrcode.vue'
import {
  apiGetFullWhatsAppList,
  apiAddWhatsApp,
  apiUpdateWhatsAppType,
  apiDeleteWhatsApp,
} from '@/views/pages/komship/customer/Ai/service/api.whatsApp.service'
import { apiActivateAgent } from '@/views/pages/komship/customer/Ai/service/api.agent.service'

export default {
  name: 'Koneksi',
  components: { BSpinner, QrcodeVue },
  data() {
    return {
      loadingQr: false,
      qrCode: '',
      connected: false,
      isNewlyAddedNumber: false,
      defaultWa: null,
      phoneNumber: null,
      phoneNumberId: null,
      inputPhoneNumber: '',
      inputError: '',
      serverWAFull: true,
      setScanWap: false,
      setScanKomchat: false,
      isLoading: false,
      interval: null,
    }
  },
  computed: {
    ...mapState('whatsapp', ['check_wa', 'phone_number']),
    ...mapState('dashboard', ['profile']),
  },
  async mounted() {
    try {
      await this.$store.dispatch('whatsapp/getUpdateDashboardWa')
    } catch (e) {
      console.error(e)
    }
    this.checkServer()
  },
  async beforeRouteLeave(to, from, next) {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    await this.cleanupUnconnectedNumber()
    next()
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.cleanupUnconnectedNumber()
  },
  methods: {
    async cleanupUnconnectedNumber() {
      if (this.isNewlyAddedNumber && !this.connected && this.phoneNumberId) {
        const idToDelete = this.phoneNumberId
        this.isNewlyAddedNumber = false
        try {
          await apiDeleteWhatsApp(idToDelete)
        } catch (e) {
          console.error('Failed to cleanup unconnected number:', e)
        }
      }
    },
    async onBack() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
      await this.cleanupUnconnectedNumber()
      if (this.$route.params.returnRoute) {
        this.$router.push({
          name: this.$route.params.returnRoute,
          params: this.$route.params.returnParams || {},
        })
      } else {
        this.$router.push({ name: 'dashboard-whatsapp' })
      }
    },
    async checkNumber() {
      this.disabledCheckNumber = true
      const url = '/v1/setting/check-number'
      const params = {
        phone_number: `0${this.inputPhoneNumber}`,
      }
      this.isLoading = true
      await this.$http_komship.get(url, { params })
        .then(res => {
          const { code } = res.data
          if (code === 200) {
            this.postNumber()
          } else if (code === 1001) {
            this.inputError = '*Maaf, nomor yang Anda masukkan sudah terdaftar'
            this.isLoading = false
          } else if (code === 1002) {
            this.inputError = '*Nomor yang Anda masukkan tidak terhubung dengan WhatsApp'
            this.isLoading = false
          }
          this.disabledCheckNumber = false
        })
        .catch(() => {
          this.disabledCheckNumber = false
          this.isLoading = false
        })
    },
    async postNumber() {
      const url = '/v2/wap/add-number'
      this.isLoading = true
      const savedPhone = `0${this.inputPhoneNumber}`
      try {
        const res = await this.$http_komship.post(url, {
          partner_id: this.profile.partner_id,
          phone_number: savedPhone,
        })
        const { code } = res.data
        if (code === 200) {
          this.$bvModal.hide('modal-add-number')
          this.isLoading = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sukses',
              icon: 'CheckIcon',
              text: 'Nomor kamu berhasil tersimpan',
              variant: 'success',
            },
          }, 500)

          const isCsAiFlow = this.$route.params.returnRoute === 'ai-customer-service'
            || this.$route.params.autoActivateAgentId

          if (isCsAiFlow) {
            try {
              await this.$store.dispatch('whatsapp/getUpdateDashboardWa')
            } catch (e) {
              console.error(e)
            }

            // Fetch full list to find newly created record with its ID
            let createdItem = null
            try {
              const listRes = await apiGetFullWhatsAppList()
              const items = listRes.data?.data || []
              createdItem = items.find(
                item => item.phone_number === savedPhone
                  || String(item.phone_number).replace(/\D/g, '').endsWith(this.inputPhoneNumber),
              )
            } catch (e) {
              console.error('Error fetching newly registered WA number:', e)
            }

            if (createdItem && createdItem.id) {
              this.phoneNumberId = createdItem.id
              this.phoneNumber = createdItem.phone_number
              this.isNewlyAddedNumber = true

              try {
                await apiUpdateWhatsAppType(createdItem.id, 'komchat_ai')
              } catch (err) {
                console.error('Failed to set type to komchat_ai:', err)
              }
              await this.getQRCode()
              if (this.interval) {
                clearInterval(this.interval)
              }
              this.interval = setInterval(() => {
                this.getQRCode()
              }, 13000)
              return
            }
          }

          if (this.$route.params.returnRoute && this.$route.params.returnRoute !== 'dashboard-whatsapp') {
            this.$router.push({
              name: this.$route.params.returnRoute,
              params: this.$route.params.returnParams || {},
            })
          } else {
            this.$router.push({ name: 'dashboard-whatsapp' })
          }
        }
      } catch (err) {
        this.isLoading = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failure',
            icon: 'AlertCircleIcon',
            text: 'Gagal Menyimpan Nomormu',
            variant: 'danger',
          },
        }, 500)
        this.onBack()
      }
    },
    formatPhoneNumber(value) {
      const numericValue = value.replace(/[^\d]/g, '')
      if (numericValue.startsWith('62')) {
        return numericValue.substr(2)
      }
      if (numericValue[0] !== '8') {
        return numericValue.slice(1)
      }
      return numericValue.substr(0, 15)
    },
    async checkWA() {
      this.defaultWa = this.check_wa.is_notification_whatsapp
      if (this.defaultWa !== 2) {
        this.$router.push({ name: 'opsional-feature' })
      } else if (this.$route.params.number === undefined) {
        this.$bvModal.show('modal-add-number')
      } else {
        this.phoneNumber = this.$route.params.number.phone_number
        this.phoneNumberId = this.$route.params.number.id
        if (this.$route.params.isNewNumber) {
          this.isNewlyAddedNumber = true
        }

        // If number object lacks id, attempt lookup or registration
        if (!this.phoneNumberId && this.phoneNumber) {
          try {
            const listRes = await apiGetFullWhatsAppList()
            const items = listRes.data?.data || []
            const targetDigits = String(this.phoneNumber).replace(/\D/g, '')
            const found = items.find(
              i => i.phone_number === this.phoneNumber
                || String(i.phone_number).replace(/\D/g, '').endsWith(targetDigits)
                || targetDigits.endsWith(String(i.phone_number).replace(/\D/g, '')),
            )
            if (found && found.id) {
              this.phoneNumberId = found.id
              this.phoneNumber = found.phone_number
            } else if (this.profile?.partner_id) {
              const fullPhone = this.phoneNumber.startsWith('0') ? this.phoneNumber : `0${targetDigits.replace(/^62/, '')}`
              await apiAddWhatsApp(fullPhone, this.profile.partner_id)
              try {
                await this.$store.dispatch('whatsapp/getUpdateDashboardWa')
              } catch (e) {
                console.error(e)
              }
              const refreshed = await apiGetFullWhatsAppList()
              const newlyFound = (refreshed.data?.data || []).find(
                i => i.phone_number === fullPhone
                  || String(i.phone_number).replace(/\D/g, '').endsWith(targetDigits),
              )
              if (newlyFound && newlyFound.id) {
                this.phoneNumberId = newlyFound.id
                this.phoneNumber = newlyFound.phone_number
                this.isNewlyAddedNumber = true
              }
            }
          } catch (e) {
            console.error('Error resolving WA number ID:', e)
          }
        }

        await this.getQRCode()
        // Retry fetch QR kedua kali setelah delay 1.5 detik jika QR pertama belum muncul atau session masih inisialisasi
        if (!this.qrCode && !this.connected) {
          await new Promise(resolve => setTimeout(resolve, 1500))
          await this.getQRCode()
        }

        if (this.interval) {
          clearInterval(this.interval)
        }
        this.interval = setInterval(() => {
          this.getQRCode()
        }, 13000)
      }
    },
    async onConnected() {
      if (this.connected) return
      this.connected = true
      this.isNewlyAddedNumber = false
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }

      const typeScan = this.$route.params.type || this.$route.params.number?.type || 'komchat_ai'
      const num = this.phoneNumberId || this.$route.params.number?.id
      const autoActivateAgentId = this.$route.params.autoActivateAgentId || this.$route.params.agentId

      if (typeScan === 'komchat_ai' || this.$route.params.type === 'komchat_ai' || autoActivateAgentId) {
        try {
          if (num) await apiUpdateWhatsAppType(num, 'komchat_ai')
          if (autoActivateAgentId) {
            await apiActivateAgent(autoActivateAgentId, true)
          }
        } catch (e) {
          console.error(e)
        }
      }

      try {
        await Promise.allSettled([
          this.$store.dispatch('komchat/getWhatsAppList'),
          this.$store.dispatch('whatsapp/getUpdateDashboardWa'),
        ])
      } catch (e) {
        console.error(e)
      }

      this.$toast_success({ message: 'Selamat, nomor kamu berhasil terhubung' })
      const returnRoute = this.$route.params.returnRoute || 'dashboard-whatsapp'
      this.$router.push({
        name: returnRoute,
        params: this.$route.params.returnParams || {},
      })
    },
    async getQRCode() {
      this.loadingQr = true
      const typeScan = this.$route.params.type || this.$route.params.number?.type || 'komchat_ai'
      const num = this.phoneNumberId || this.$route.params.number?.id

      if (!num) {
        this.loadingQr = false
        return
      }

      if (!this.connected) {
        try {
          const res = await newAxiosIns.get(`/komship/api/v1/whatsapp/generate-qr/${typeScan}/${num}`)
          this.loadingQr = false
          const { data, meta } = res.data
          if (meta && meta.code === 201) {
            await this.onConnected()
          } else if (data && data.qr_code) {
            this.qrCode = data.qr_code
          }
        } catch (err) {
          this.loadingQr = false
          const metaCode = err?.response?.data?.meta?.code
          const metaMsg = err?.response?.data?.meta?.message || err?.response?.data?.message || ''

          // 201: connected, 409 + "already connected": user baru saja scan QR fisik di HP
          // Abaikan 409 connected palsu jika nomor baru belum pernah generate/tampil QR
          const isFalseConnected = this.isNewlyAddedNumber && !this.qrCode
          if ((metaCode === 201 || (metaCode === 409 && metaMsg.includes('already connected'))) && !isFalseConnected) {
            await this.onConnected()
          } else if (this.qrCode && !this.isNewlyAddedNumber) {
            try {
              const listRes = await apiGetFullWhatsAppList()
              const items = listRes.data?.data || []
              const target = items.find(i => Number(i.id) === Number(num))
              if (target && target.is_scan === true) {
                await this.onConnected()
              }
            } catch (checkErr) {
              console.error('Error checking WA scan status:', checkErr)
            }
          }
        }
      }
    },
    checkServer() {
      this.$http_komship.get('/v2/wap/check/server')
        .then(res => {
          const { data } = res.data
          this.serverWAFull = data.is_server_full
          if (this.serverWAFull) {
            this.$swal({
              title: 'Server Penuh',
              html: 'Silahkan tunggu 1-3 jam untuk kami menyiapkan layanan ini untukmu. Hubungi live chat jika lebih dari 3 jam notifikasi Whatsapp kamu belum siap',
              width: 500,
              imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
              confirmButtonText: 'Mengerti',
              confirmButtonClass: 'btn btn-primary',
              reverseButtons: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(response => {
              if (response.isConfirmed) {
                this.$router.push('/opsional-feature/notifikasi-wa-premium')
              }
            })
          } else {
            this.checkWA()
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failure',
              icon: 'AlertCircleIcon',
              text: 'Server penuh, Tunggu beberapa saat lagi',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
